// extracted by mini-css-extract-plugin
export var tosLink = "_as-0";